module.exports = __webpack_public_path__ + "static/media/SM-Slider_TrackBackground_hover.131baa8c.svg";